import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "stores/useUser";
import {
  captureEvent,
  identifyPostHogUser,
  initPostHog,
  isPostHogEnabled,
  resetPostHogUser,
} from "utils/posthog";

const PostHogTracker = () => {
  const location = useLocation();
  const { user } = useUser();

  useEffect(() => {
    if (!isPostHogEnabled()) {
      return;
    }

    initPostHog();
  }, []);

  useEffect(() => {
    if (!isPostHogEnabled()) {
      return;
    }

    if (user?.uid) {
      identifyPostHogUser(user);
      return;
    }

    resetPostHogUser();
  }, [user]);

  useEffect(() => {
    if (!isPostHogEnabled()) {
      return;
    }

    captureEvent("$pageview", {
      $current_url: window.location.href,
      pathname: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default PostHogTracker;
